// extracted by mini-css-extract-plugin
export default {"root":"ReportingPage_root__KKr0E"};